"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicButton = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Button_1 = tslib_1.__importDefault(require("@material-ui/core/Button"));
var BasicButton_style_1 = require("./BasicButton.style");
exports.BasicButton = function (_a) {
    var label = _a.label, onClick = _a.onClick, disabled = _a.disabled, customClasses = _a.customClasses;
    var classes = customClasses ? customClasses : BasicButton_style_1.BasicButtonStyles(); // Should override, TODO
    return (react_1.default.createElement(Button_1.default, { classes: {
            disabled: classes.buttonDisabled,
            root: classes.button,
        }, color: "primary", disabled: disabled, onClick: function () { return onClick(); } }, label));
};
